<div class="d-block">
    <app-expandable-content>
        <div title class="d-flex align-items-center">
            <div class="flex-shrink-0 flex-grow-1">
                <strong>Contenus enregistrés</strong>
            </div>
            <div class="flex-grow-0">
                <app-button style="flex-grow: 0;"
                            [withMargin]="false"
                            [withPadding]="false"
                            iconName="plus"
                            (clickEvent)="createContentModel()"></app-button>
            </div>
            <div class="flex-grow-0">
                <app-button style="flex-grow: 0;"
                            iconName="settings"
                            [withMargin]="false"
                            [withPadding]="false"
                            (clickEvent)="redirectTo('podopro-app/communication/modeles');"></app-button>
            </div>
        </div>
        <div class="d-flex gap-4">
            <app-chips [onlyOneSelection]="true" [forceOneSelection]="true" [items]="typeItems" [onlyShowSelected]="true"
                       (selectedChangedEvent)="typeSelected($event)"></app-chips>
        </div>
        <div class="divider"></div>
        <app-loading *ngIf="(communicationContentModelFindAllService.loading$ | async) else modelsNotLoading"
                     [loading]="true" [showText]="false"></app-loading>
        <ng-template #modelsNotLoading>

            <div cdkDropList
                 [cdkDropListConnectedTo]="['test']" style="max-height: 150px;">
                <ng-container *ngIf="formGroup.get('typeValue').value === SUBSTITUTIONS else contentModels">
                    <app-loading [loading]="substitutionService.loading$ | async" [showText]="false"></app-loading>
                    <app-error-text [error]="error" *ngIf="(substitutionService.error$ | async) as error" message="Chargement des expressions dynamiques impossible"></app-error-text>

                    <app-chips [onlyOneSelection]="true" [forceOneSelection]="true" [items]="substitutionCategories" (selectedChangedEvent)="selectedSubstitutionCategoryChanged($event)"></app-chips>
                    <div class="divider"></div>
                    <div class="m-l-8 d-flex align-items-center flex-wrap gap-4" *ngIf="selectedSubstitutionCategory">
                        <app-button cdkDrag  [cdkDragData]="'|' + substitution.textToReplace + '|'"
                                    fill="solid"
                                    [label]="substitution.name"
                                    *ngFor="let substitution of selectedSubstitutionCategory.substitutions"
                                    (clickEvent)="contentModelChanged('|' + substitution.textToReplace + '|')"></app-button>
                    </div>
                </ng-container>
                <ng-template #contentModels>
                    <div class="d-flex flex-wrap gap-8">
                        <ng-container *ngFor="let contentModel of (communicationContentModelFindAllService.entities$ | async)">
                            <app-button cdkDrag style="background: white;" [cdkDragData]="contentModel.content"
                                        size="small"
                                        fill="solid"
                                        [label]="contentModel.summary.label + '-test'"
                                        (clickEvent)="contentModelChanged(contentModel.content)"></app-button>
                        </ng-container>
                    </div>
                </ng-template>
            </div>
        </ng-template>
    </app-expandable-content>
    <app-expandable-content>
        <strong title>Générer avec l'IA</strong>
        <div class="d-flex gap-4">
            <ng-content select="[aiGenerationButtons]"></ng-content>
            <app-button label="Reformuler" iconName="sparkles" fill="solid"
                        title="Vous pouvez sélectionner le texte à reformuler dans le contenu ci-dessous."
                        (clickEvent)="openRephraseDialog()"></app-button>
            <app-button label="Corriger l'orthographe" iconName="sparkles" fill="solid"
                        title="Vous pouvez sélectionner le texte à corriger dans le contenu ci-dessous."
                        (clickEvent)="openSpellCheckDialog()"></app-button>
        </div>
    </app-expandable-content>
</div>

<div class="row">
    <div class="col-12">
        <app-form-field label="Contenu" [size]="12">
            <div class="d-flex gap-5 flex-wrap" style="max-height: 100px;overflow-y: auto;">
                <ng-content select="[contentButtons]"></ng-content>
            </div>
            <div class="text-center" *ngIf="contentLoading" >
                <app-loading [showText]="false"></app-loading>
            </div>

            <div cdkDropList id="test"
                 (cdkDropListDropped)="drop($event)"
                 style="min-height: 200px;">

                <app-rich-text-editor #richTextEditorComponent
                                      [audioTranscriptionConfig]="audioTranscriptionConfig"
                                      display="normal"
                                      [parentFormGroup]="parentFormGroup"
                                      [style.display]="contentLoading ? 'none' : 'block'"
                                      [parentFormControlName]="parentFormControlName"
                ></app-rich-text-editor>
            </div>
        </app-form-field>
    </div>

</div>
